<template>
    <div class="main">
        移动世界
    </div>
</template>

<script>
export default {

    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {}

}

</script>

<style lang="scss" scoped>
h1 {
    width: 100px;
}
</style>
